/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { useField, useFormikContext } from 'formik';
import { selectComboBoxOptions, selectStatusByName } from '@redux/selectors/FormSelector';

const SupplementComboBox = ({ uid, supplementType }) => {
  const name = `Supplements.[${uid}].SupplementType`;
  const [field, meta] = useField(name);
  const { setFieldTouched, setFieldValue } = useFormikContext();

  const supplementTypeOptions = useSelector(state => selectComboBoxOptions(state, 'SupplementType'));
  const suppType = useMemo(() => supplementTypeOptions.find(opt => opt.value === supplementType), [supplementType, supplementTypeOptions]);

  const status = useSelector(state => selectStatusByName(state, 'Supplements'));

  // FlexRule does not return a validation result per supplement instance, but instead a single status for all supplements.
  // Therefore, it is necessary to check MEASURE and JUDICIAL (the only two valid selections) before displaying validation error message.
  const isValid = (meta.touched && status?.errorMessage && field.value !== 'MEASURE' && field.value !== 'JUDICIAL');

  return (
    <div className="form-group">
      <label className="form-label" htmlFor={name}>
        Supplement Type
      </label>
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        id={name}
        name={name}
        onBlur={() => setFieldTouched(name, true)}
        // react-select sends synthetic events, and will not work with formik change handler
        onChange={option => ((option === null) ? setFieldValue(name, '') : setFieldValue(name, option.value))}
        closeMenuOnSelect
        value={suppType}
        isClearable // option will be null if user clears combo box
        options={supplementTypeOptions}
        placeholder="Choose one"
      />
      {isValid && (<div className="invalid-feedback">{status.errorMessage}</div>)}
    </div>
  );
};

SupplementComboBox.propTypes = {
  uid: PropTypes.string,
  supplementType: PropTypes.string,
};

export default SupplementComboBox;
